import React from "react";
import { Link } from "react-router-dom";
import helpersNumbers from "../../../helpers/numbers";

export default function Charge() {
  return (
    <div className="px-2 ">
      <div className="d-flex">
        <div className="nav-item d-flex align-items-center px-3 py-2 finance-number">
          <span dir="ltr"> : موجودی </span>
          <span className="px-2 letter-spacing-finance-number">
            {helpersNumbers.toPersianNum(
              helpersNumbers.toFormatFinanceNumber(300000)
            )}
          </span>
          <span>تومان</span>
        </div>
        <div className="d-none d-lg-flex">
          <Link to="/finance/charge" className="btn btn-success">
            افزایش اعتبار{" "}
          </Link>
        </div>
      </div>
    </div>
  );
}
